import { Api } from "src/utils/api";
import {
  CogsCreateDto,
  CogsDeleteQueryParams,
  CogsQueryParams,
  CogsResponseDto,
  CogsUpdateBody,
  CogsUpdateQueryParams,
} from "./data-entry.model";

const DATA_ENTRY_API_BASE_URL = `${import.meta.env.BUILD_API_BASE_URL}/amazon/v1`;

class DataEntryApi extends Api {
  constructor() {
    super(DATA_ENTRY_API_BASE_URL);
  }

  public async uploadCogsData(data: CogsCreateDto): Promise<void> {
    const response = await this.post<void>("/cogs", data);
    return response;
  }

  public async updateCogsData(
    query: CogsUpdateQueryParams,
    body: CogsUpdateBody,
  ): Promise<void> {
    const {
      product_id,
      date_start,
      date_end,
      product_source = "AMAZON",
    } = query;

    const queryString = new URLSearchParams({
      product_id,
      date_start,
      date_end,
      product_source,
    }).toString();

    const url = `/cogs?${queryString}`;

    return this.put<void>(url, body);
  }

  public async deleteCogsData(params: CogsDeleteQueryParams): Promise<void> {
    const queryString = new URLSearchParams({
      product_id: params.product_id,
      date_start: params.date_start,
      date_end: params.date_end,
      product_source: params.product_source || "AMAZON",
    }).toString();

    const url = `/cogs?${queryString}`;

    return this.delete<void>(url);
  }

  public async listCogsData(
    params?: CogsQueryParams,
  ): Promise<CogsResponseDto[]> {
    const query = new URLSearchParams();

    if (params?.offset !== undefined)
      query.append("offset", params.offset.toString());
    if (params?.limit !== undefined)
      query.append("limit", params.limit.toString());

    if (Array.isArray(params?.asin)) {
      for (const asin of params.asin) {
        query.append("asin", asin);
      }
    } else if (typeof params?.asin === "string") {
      query.append("asin", params.asin);
    }

    return this.get<CogsResponseDto[]>(`/cogs?${query.toString()}`);
  }
}
export const dataEntryApi = new DataEntryApi();
